const PHONE_FIELD_NAMES = ['phone', 'parent_phone'];

export const isPhoneField = (fieldName) => PHONE_FIELD_NAMES.includes(fieldName);

export const normalizeIndonesianPhoneValue = (value) => {
  const digitsOnly = String(value ?? '').replace(/\D/g, '');

  if (digitsOnly.startsWith('62')) {
    return `08${digitsOnly.slice(2)}`;
  }

  if (digitsOnly.startsWith('8')) {
    return `0${digitsOnly}`;
  }

  return digitsOnly;
};

export const isValidIndonesianPhoneValue = (value) => /^08\d{8,11}$/.test(String(value ?? ''));

export const handlePhoneKeyDown = (event) => {
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return;
  }

  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
  ];

  if (allowedKeys.includes(event.key)) {
    return;
  }

  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};